import api from '@/api'

const state = {
  cities: [],
  provinces: [],
  districts: [],
  subDistricts: [],
  urbanVillages: [],
  paymentMethods: [],
  goodsCategories: [],
  goodsCategoryDetail: {},
  bankCodes: [],
  ownershipTypes: [],
  vehicleTypes: [],
  driverLicenseTypes: []
}
const actions = {
  getCities({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.master.cities(params).then(
        response => {
          commit('setCities', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getProvinces({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.province().then(
        response => {
          commit('setProvinces', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDistricts({ commit }, { provinceId }) {
    return new Promise((resolve, reject) => {
      api.master.district(provinceId).then(
        response => {
          commit('setDistricts', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getSubDistricts({ commit }, { provinceId, districtId }) {
    return new Promise((resolve, reject) => {
      api.master.subDistrict(provinceId, districtId).then(
        response => {
          commit('setSubDistricts', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getUrbanVillages({ commit }, { provinceId, districtId, subDistrictId }) {
    return new Promise((resolve, reject) => {
      api.master.urbanVillage(provinceId, districtId, subDistrictId).then(
        response => {
          commit('setUrbanVillages', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPaymentMethods({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.paymentMethods().then(
        response => {
          commit('setPaymentMethods', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getGoodsCategories({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.master.goodsCategories(params).then(
        response => {
          commit('setGoodsCategories', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getGoodsCategoryDetail({ commit }, { code }) {
    return new Promise((resolve, reject) => {
      api.master.goodsCategoryDetail(code).then(
        response => {
          commit('setGoodsCategoryDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createGoodsCategory({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.master.createGoodsCategory(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getBankCodes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.bankCodes().then(
        response => {
          commit('setBankCodes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getOwnershipTypes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.ownershipTypes().then(
        response => {
          commit('setOwnershipTypes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getVehicleTypes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.vehicleTypes().then(
        response => {
          commit('setVehicleTypes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDriverLicenseTypes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.driverLicenseTypes().then(
        response => {
          commit('setDriverLicenseTypes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setCities(state, value) {
    state.cities = value
  },
  setProvinces(state, value) {
    state.provinces = value
  },
  setDistricts(state, value) {
    state.districts = value
  },
  setSubDistricts(state, value) {
    state.subDistricts = value
  },
  setUrbanVillages(state, value) {
    state.urbanVillages = value
  },
  setPaymentMethods(state, value) {
    state.paymentMethods = value
  },
  setGoodsCategories(state, value) {
    state.goodsCategories = value
  },
  setGoodsCategoryDetail(state, value) {
    state.goodsCategoryDetail = value
  },
  setBankCodes(state, value) {
    state.bankCodes = value
  },
  setOwnershipTypes(state, value) {
    state.ownershipTypes = value
  },
  setVehicleTypes(state, value) {
    state.vehicleTypes = value
  },
  setDriverLicenseTypes(state, value) {
    state.driverLicenseTypes = value
  }
}
const getters = {
  cities: state => state.cities,
  provinces: state => state.provinces,
  districts: state => state.districts,
  subDistricts: state => state.subDistricts,
  urbanVillages: state => state.urbanVillages,
  paymentMethods: state => state.paymentMethods,
  goodsCategories: state => state.goodsCategories,
  goodsCategoryDetail: state => state.goodsCategoryDetail,
  bankCodes: state => state.bankCodes,
  ownershipTypes: state => state.ownershipTypes,
  vehicleTypes: state => state.vehicleTypes,
  driverLicenseTypes: state => state.driverLicenseTypes
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
